<div class="container">
    <searchable-list [options]="data" (optionClicked)="optionClicked($event)"></searchable-list>
</div>

